import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.379 5.416 9.686.276A.95.95 0 0 0 8.988 0c-.3 0-.5.092-.7.276l-5.591 5.14C.9 6.976 0 9.088 0 11.291c0 2.204.899 4.314 2.596 5.875s3.995 2.386 6.392 2.386c2.396 0 4.693-.825 6.39-2.386 3.496-3.213 3.497-8.446.001-11.75M13.98 15.881a7.54 7.54 0 0 1-4.994 1.835c-1.897 0-3.594-.643-4.893-1.836-1.398-1.285-2.097-2.844-2.097-4.59 0-1.743.7-3.304 1.997-4.497l4.894-4.59 4.993 4.59c2.796 2.478 2.796 6.517.1 9.087M6 12.71c0 .54-.448.976-1 .976s-1-.437-1-.976a.99.99 0 0 1 1-.979.99.99 0 0 1 1 .979"
    }, null, -1)
  ]))]))
}
export default { render: render }